
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wedding-podcast",
      function () {
        return require("private-next-pages/wedding-podcast/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wedding-podcast"])
      });
    }
  